import React from 'react';
import EmailFooterIcon from '../../assets/EmailFooterIcon.png';
import FacebookGreenIcon from '../../assets/FacebookGreenIcon.png';
import InstaGreenIcon from '../../assets/InstaGreenIcon.png';
import YoutubeGreenIcon from '../../assets/YoutubeGreenIcon.png';
import TwitterGreenIcon from '../../assets/TwitterGreenIcon.png';
import RedditGreenIcon from '../../assets/RedditGreenIcon.png';
import LinkedinGreenIcon from '../../assets/LinkedinGreenIcon.png';
import LogoM from '../../assets/LogoM.png';
import CompanyLogo from '../../assets/CompanyLogo.png';
import './Footer.scss';
import { Link } from 'react-router-dom';

export default function Footer() {
  const handleEmailClick = () => {
    const email = 'social@mything.ai';
    const subject = 'Feedback';
    const body = 'Hello MyPDF.club,';
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(gmailLink, '_blank');
  };

  return (
    <div className="footer-container">
      <div className="column-first">
        <div className="first-row-logo">
          <img src={CompanyLogo} alt="Logo" className='companyLogo' />
          <div className="company-details">
            <div className="company-name">Crafted for security, designed for ease</div>
            <img src={LogoM} alt="Company Logo" />
          </div>
        </div>
        <div className="second-row-content">
          <div className="facebook">
            <img src={FacebookGreenIcon} alt="Facebook Icon" />
          </div>
          <div className="instagram">
            <img src={InstaGreenIcon} alt="Instagram Icon" />
          </div>
          <div className="youtube">
            <img src={YoutubeGreenIcon} alt="Youtube Icon" />
          </div>
          <div className="youtube">
            <img src={TwitterGreenIcon} alt="Twitter Icon" />
          </div>
          <div className="youtube">
            <img src={LinkedinGreenIcon} alt="Linkedin Icon" />
          </div>
          <div className="youtube">
            <img src={RedditGreenIcon} alt="Reddit Icon" />
          </div>
        </div>
        <div className="third-row-text">
          Whether it’s encrypting a file before sharing or quickly converting docs, Mypdf.club makes working with PDFs effortless. Trusted by professionals, built for everyone.
        </div>
        <div className="fourth-row-copyright">
          <span>© </span>
          2024 All Rights Reserved.
        </div>
      </div>

      <div className="column-second">
        <div className="first">
          <div className="about">ABOUT</div>
          <div role="button" tabIndex={0} className="items">
            <Link to="/blog" className="nav-link">Blogs</Link>
          </div>
        </div>
        <div className="second">
          <div className="product">PRODUCT</div>
          <div role="button" tabIndex={0} className="items">
            <Link to="/pricing" className="nav-link">Pricing</Link>
          </div>
          <div role="button" tabIndex={0} className="items">
            <Link to="/tools" className="nav-link">Tools</Link>
          </div>
        </div>
        <div className="third">
          <div className="pricing">Legal</div>
          <div role="button" tabIndex={0} className="items">
            <Link to="/privacy-policy" className="nav-link">Privacy Policy</Link>
          </div>
          <div role="button" tabIndex={0} className="items">
            <Link to="/delete-account" className="nav-link">Delete Account</Link>
          </div>
          <div role="button" tabIndex={0} className="items">
            <Link to="/delete-data" className="nav-link">Delete Data</Link>
          </div>
        </div>
      </div>

      <div className="divider" />

      <div className="column-third">
        <div className="email-card">
          <div className="contact-text">
            Contact us @
          </div>
          <div className="email-id-container">
            <div role="button" tabIndex={0} aria-label="button" className="email-icon-container" onClick={handleEmailClick}>
              <img src={EmailFooterIcon} alt="email" />
            </div>
            <button onClick={handleEmailClick} className="email-id">
              social@mything.ai
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
